export const version = "providers/5.5.0";
//# sourceMappingURL=_version.js.map